// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import '../styles/SearchResultBox.css'
import * as Types from "../data/utils/types";
import { useNavigate } from 'react-router-dom';
import Loading from './LinearLoading';
import NoResults from './NoResults';

type MyComponentProps = {
    searchDataResponse: any | undefined;
    type: string;
}

export const SearchResultBox = (searchResultProp: MyComponentProps) => {

    const navigate = useNavigate();

    const navigateTo = (id: string) => {
        if (searchResultProp.type === "case") {
            navigate(`/support/cases/${id}`);
        } else if (searchResultProp.type === "account") {
            navigate(`/support/accounts/${id}`);
        } else if (searchResultProp.type === "myAccount") {
            navigate(`/support/accounts/${id}`);
        } else if (searchResultProp.type === "project") {
            navigate(`/support/projects/${id}`);
        }
    }

    if (typeof searchResultProp.searchDataResponse === 'undefined') {
        return <div className="container">
            <br />
            <div className='row justify-content-center'>
                <div className="col-12 col-md-10 col-lg-6">
                    <div className="card card-body search-result-body">
                        <Loading />
                    </div>
                </div>
            </div>
        </div>;
    }

    if (searchResultProp.type === "case" && searchResultProp.searchDataResponse.cases.length === 0) {
        return <NoResults />;
    } else if (searchResultProp.searchDataResponse.length === 0) {
        return <NoResults />;
    }

    return (
        <>
            {
                searchResultProp.type === "case" ?
                    searchResultProp.searchDataResponse.cases.map((item: Types.caseDetails, index: number) => {
                        const firstItem = item.caseId;
                        const secondItem = item.number;

                        return (
                            <div className="container" key={index} onClick={() => navigateTo(item.number)}>
                                <br />
                                <div className='row justify-content-center'>
                                    <div className="col-12 col-md-10 col-lg-7">
                                        <div className="card card-body card-hover search-result-body" >
                                            <h5><b>{firstItem}</b></h5>
                                            <h6>{secondItem}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                    :
                    searchResultProp.searchDataResponse.map((item: any, index: number) => {
                        let firstItem: string = "";
                        let secondItem: string = "";

                        if (searchResultProp.type === "account" || searchResultProp.type === "myAccount") {
                            firstItem = item.name;
                            secondItem = item.number;
                        } else if (searchResultProp.type === "project") {
                            firstItem = item.name;
                            secondItem = item.number;
                        }

                        return (
                            <div className="container" key={index} onClick={() => navigateTo(item.number)}>
                                <br />
                                <div className='row justify-content-center'>
                                    <div className="col-12 col-md-10 col-lg-7">
                                        <div className="card card-body card-hover search-result-body" >
                                            <h5><b>{firstItem}</b></h5>
                                            <h6>{secondItem}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
            }
        </>
    );
}
